
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { updatePushToken } from 'api/auth';

// Set listeners references (for later cleanup)
let regListenerHandle: any = null;
let notifListenerHandle: any = null;


// Handle push notifications setup
export async function setupPushNotifications(isLoggedIn: boolean): Promise<void> {
    // If not running on a native platform, exit
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    // If user's not logged-in, exit
    if (!isLoggedIn) {
      return;
    }

    // Cleanup old listeners if exists (avoid duplicate listeners or memory leaks) this might happen when function is called multiple times
    if (regListenerHandle && regListenerHandle.remove) regListenerHandle.remove();
    if (notifListenerHandle && notifListenerHandle.remove) notifListenerHandle.remove();

    // Attach listner to register to run before registration to avoid missing the event if registration is fast
    // When it happens, we will get a token, unique to this device, when register, we will update in server the push token to allow sending personal msgs to this device
    // Every login will update this token in server, since in some occasions the token can be updated
    regListenerHandle = await PushNotifications.addListener('registration', token => {
      // Update push token in server, 3 retries (on 5xx server errors) with exponential backoff (total 4 tries)
      if (typeof token?.value === 'string' && token.value) {
        updatePushToken(token.value).catch(() => {}); // Ignore errors, we don't want to interfer signup if could not update push token
      }
    });
    
    // Add listener for push notification received // todo: In the future, we might want to do action in app based on notification text, for now, we just log it
    // notifListenerHandle = await PushNotifications.addListener('pushNotificationReceived', notification => {
    //   console.log(`Notification received: ${notification.title} - ${notification.body}`);
    // });


    // Register the device with push notifications
    try {
      let permStatus = await PushNotifications.checkPermissions();
      if (permStatus.receive !== 'granted') {
        permStatus = await PushNotifications.requestPermissions();
      }
      if (permStatus.receive !== 'granted') {
        throw new Error('User denied permissions!');
      }
      await PushNotifications.register();
    } catch (err) {
      console.error('Error registering for push notifications:', err);
    }

}
